import isPlainObject from 'onyx-common/isPlainObject'
import hasKey from 'onyx-common/hasKey'

const isPeItemObject = (item) => {
  if (!isPlainObject(item)) return false
  return hasKey(item, 'instanceId')
}

export default isPeItemObject
